__turbopack_context__.v({
  "eds-event-card--consumer": "EventsBucket-module-scss-module__8TU-QG__eds-event-card--consumer",
  "eds-example-grid-coloring": "EventsBucket-module-scss-module__8TU-QG__eds-example-grid-coloring",
  "eds-example-grid-content": "EventsBucket-module-scss-module__8TU-QG__eds-example-grid-content",
  "eds-example-sidebar-content": "EventsBucket-module-scss-module__8TU-QG__eds-example-sidebar-content",
  "eds-g-cell": "EventsBucket-module-scss-module__8TU-QG__eds-g-cell",
  "eds-g-sidebar": "EventsBucket-module-scss-module__8TU-QG__eds-g-sidebar",
  "eds-g-view": "EventsBucket-module-scss-module__8TU-QG__eds-g-view",
  "eds-media-card-content__content-container": "EventsBucket-module-scss-module__8TU-QG__eds-media-card-content__content-container",
  "fade-in": "EventsBucket-module-scss-module__8TU-QG__fade-in",
  "fade-out": "EventsBucket-module-scss-module__8TU-QG__fade-out",
  "feedCardCell": "EventsBucket-module-scss-module__8TU-QG__feedCardCell",
  "feedEventsBucket": "EventsBucket-module-scss-module__8TU-QG__feedEventsBucket",
  "feedEventsBucketContent": "EventsBucket-module-scss-module__8TU-QG__feedEventsBucketContent",
  "feedEventsBucketContentLoading": "EventsBucket-module-scss-module__8TU-QG__feedEventsBucketContentLoading",
  "feedEventsBucketMobile": "EventsBucket-module-scss-module__8TU-QG__feedEventsBucketMobile",
  "feedEventsBucketSeparator": "EventsBucket-module-scss-module__8TU-QG__feedEventsBucketSeparator",
  "feedEventsBucket__separator": "EventsBucket-module-scss-module__8TU-QG__feedEventsBucket__separator",
  "pad-bot-mn-up": "EventsBucket-module-scss-module__8TU-QG__pad-bot-mn-up",
  "premium-events-bucket__content": "EventsBucket-module-scss-module__8TU-QG__premium-events-bucket__content",
  "root": "EventsBucket-module-scss-module__8TU-QG__root",
});
